
/**
 * 表示用ファイル容量
 */
export function sizeLabel(byte:number, unit:string='mb'): string|null
{
	let alignment:number = 1;
	if('kb'===unit.toLowerCase()) {
		alignment = 1024
	} else if('mb'===unit.toLowerCase()) {
		alignment = 1024 * 1024
	} else if('gb'===unit.toLowerCase()) {
		alignment = 1024 * 1024 * 1024
	}
	let size = byte/alignment;
	return comma((Math.ceil(size*10)/10).toFixed(1)) + unit.toUpperCase()
}

/**
 * 数にコンマ付ける
 */
export function comma(num:string|number) {
	let part = String(num).match(/^(\d+)(.*)$/)
	let result = part[1].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
	if(part[2].length) result += part[2]
	return result;
}
